import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { style: {"font-size":"14px","line-height":"22px"} }
const _hoisted_2 = { style: {"font-size":"12px","color":"#999","line-height":"18px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createBlock(_component_a_select, {
    value: $setup.props.allowAll && ($setup.props.modelValue === '' || $setup.props.modelValue === null || $setup.props.modelValue === undefined) ? '' : ($setup.props.modelValue === '' ? null : $setup.props.modelValue),
    "onUpdate:value": $setup.handleChange,
    placeholder: $props.placeholder,
    "show-search": "",
    "filter-option": false,
    onSearch: $setup.handleSearch,
    onPopupScroll: $setup.handleScroll,
    onFocus: $setup.handleFocus,
    onClear: $setup.handleClear,
    loading: $setup.loading,
    "option-label-prop": "label",
    "allow-clear": "",
    disabled: $props.disabled
  }, {
    default: _withCtx(() => [
      ($props.allowAll)
        ? (_openBlock(), _createBlock(_component_a_select_option, {
            key: 0,
            value: "",
            label: "全部"
          }, {
            default: _withCtx(() => [
              _createTextVNode("全部")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.userList, (item) => {
        return (_openBlock(), _createBlock(_component_a_select_option, {
          key: item.id,
          value: item.id,
          label: item.name
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_1, _toDisplayString(item.name), 1),
              _createElementVNode("div", _hoisted_2, " ID: " + _toDisplayString(item.id), 1)
            ])
          ]),
          _: 2
        }, 1032, ["value", "label"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["value", "onUpdate:value", "placeholder", "onSearch", "onPopupScroll", "onFocus", "onClear", "loading", "disabled"]))
}